<script>
export default {
    data() {
        return {

        }
    }
}
</script>
<template>
    <div class="wrapper">
        <div class="content-wrapper pt-3">
            <div class="col-12">
                <!-- Main content -->
                <section class="content">
                    <div class="container-fluid">
                        

                        <router-view></router-view>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .btn-menu{
        position: absolute;
        right: 30px;
        z-index: 1;
    }
    .wrapper {
        padding: 0;
    }
    .content-wrapper{
        margin: 0 !important;
        background-image: url('@/assets/img/fondo.png');

        /* Center and scale the image nicely */
        background-position: top left;
        background-repeat: no-repeat;
        background-size: cover;
    }
</style>